import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ba4dfc32"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba4dfc32')) {
      api.createRecord('ba4dfc32', component.options)
    } else {
      api.reload('ba4dfc32', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ba4dfc32", function () {
      api.rerender('ba4dfc32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/Customers/index.vue"
export default component.exports